import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import Avatar from 'components/base/Avatar';
import { useState } from 'react';
import { UilOutgoingCall, UilIncomingCall } from '@iconscout/react-unicons';
import DialingSuccessChartSmall from 'components/charts/DiallingSuccessChartSmall';
import CampaignFunnelChartSmall from 'components/charts/CampaignFunnelChartSmall';
import HVASystemKPICard3 from 'components/cards/HVASystemKPICard3';

type HVACampaign = {
  id: number;
  bxpid: number;
  name: string;
  serviceid: number;
  campaigntype: number;
  campaigntypeoutbound: boolean;
  servicename: string;
  brand: string;
  campaigntypedescription: string;
};

export const hvacampaignsTablecolumns: ColumnDef<HVACampaign>[] = [
  {
    accessorKey: 'servicename',
    header: 'Service',
    cell: ({ row: { original } }) => {
      const { servicename, brand } = original;
      const [imageSrc, setImageSrc] = useState(`/brands/${brand}.png`);

      const handleImageError = () => {
        setImageSrc('/brands/default.png');
      };

      return (
        <div className="d-flex align-items-center text-body-emphasis">
          {imageSrc && (
            <Avatar
              src={imageSrc}
              size="2xl"
              alt={servicename}
              onError={handleImageError}
            />
          )}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '5%' }, className: 'pe-2 ps-0' },
      cellProps: { className: 'py-0 pe-2 ps-0 p-0 white-space-nowrap' }
    }
  },
  {
    accessorKey: 'name',
    header: 'campaign',
    cell: ({ row: { original } }) => {
      const { id, bxpid, name, servicename, brand, campaigntypeoutbound } =
        original;
      const title = servicename + ' - ' + name;
      return (
        <Link
          to={`/actualcalling/campaign/${id}/${bxpid}/${
            campaigntypeoutbound ? 'outbound' : 'inbound'
          }/${title}/${brand}`}
          className="text-body"
        >
          {name}
        </Link>
      );
    },
    meta: {
      headerProps: { style: { width: '10%' }, className: 'px-1' },
      cellProps: { className: 'fw-bold px-1 white-space-nowrap' }
    }
  },
  {
    accessorKey: 'campaigntypeoutbound',
    header: 'Type',
    cell: ({ row: { original } }) => {
      const { campaigntypeoutbound } = original;
      return (
        <div className="d-flex mx-2 align-items-center text-body-quaternary">
          {campaigntypeoutbound ? (
            <UilOutgoingCall size="22" className="text-primary" />
          ) : (
            <UilIncomingCall size="22" className="text-success" />
          )}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '5%' }, className: 'px-1' },
      cellProps: { className: 'text-body-tertiary px-1' }
    }
  },
  {
    header: 'Performance',
    cell: ({ row: { original } }) => {
      const { id, campaigntypeoutbound } = original;
      return (
        <div className="d-flex mx-2 align-items-center text-primary">
          <DialingSuccessChartSmall
            campaignid={id}
            campaignType={campaigntypeoutbound ? 'outbound' : 'inbound'}
          />
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '15%' }, className: 'px-1' },
      cellProps: { className: 'text-body-tertiary px-1' }
    }
  },
  {
    header: 'Campaign funnel',
    cell: ({ row: { original } }) => {
      const { bxpid, campaigntypeoutbound } = original;
      return (
        <div className="d-flex align-items-center text-primary">
          <CampaignFunnelChartSmall
            campaignid={bxpid}
            campaignType={campaigntypeoutbound ? 'outbound' : 'inbound'}
          />
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '35%' }, className: 'px-1' },
      cellProps: { className: 'text-body-tertiary px-1' }
    }
  },
  {
    header: 'KPI`s',
    cell: ({ row: { original } }) => {
      const { bxpid, campaigntypeoutbound } = original;
      return (
        <div className="text-primary-dark">
          <HVASystemKPICard3
            campaignid={bxpid}
            campaignType={campaigntypeoutbound ? 'outbound' : 'inbound'}
          />
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '36%' }, className: 'px-1' },
      cellProps: { className: 'text-body-tertiary px-1' }
    }
  }
];

export const HVACampaignsTable = () => {
  return (
    <div>
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger position-static"
      />
      <AdvanceTableFooter pagination />
    </div>
  );
};
